"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _webgltextureLoader = require("webgltexture-loader");

var VideoTextureLoader =
/*#__PURE__*/
function (_webgltextureLoader$W) {
  _inherits(VideoTextureLoader, _webgltextureLoader$W);

  function VideoTextureLoader() {
    _classCallCheck(this, VideoTextureLoader);

    return _possibleConstructorReturn(this, _getPrototypeOf(VideoTextureLoader).apply(this, arguments));
  }

  _createClass(VideoTextureLoader, [{
    key: "canLoad",
    value: function canLoad(input) {
      return input instanceof HTMLVideoElement;
    }
  }, {
    key: "inputHash",
    value: function inputHash(input) {
      return input;
    }
  }, {
    key: "loadNoCache",
    value: function loadNoCache(input) {
      var gl = this.gl;
      var width = input.width,
          height = input.height;
      var timeout;

      var dispose = function dispose() {
        clearTimeout(timeout);
      };

      var promise = new Promise(function (resolve, reject) {
        var checkVideoReady = function checkVideoReady() {
          if (input.videoWidth > 0) {
            var texture = gl.createTexture();
            var _width = input.videoWidth,
                _height = input.videoHeight;
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, input);
            resolve({
              texture: texture,
              width: _width,
              height: _height
            });
          } else {
            timeout = setTimeout(checkVideoReady, 100);
          }
        };

        checkVideoReady();
      });
      return {
        dispose: dispose,
        promise: promise
      };
    }
  }, {
    key: "update",
    value: function update(input) {
      var gl = this.gl;
      var res = this.get(input);
      if (!res) return;
      gl.bindTexture(gl.TEXTURE_2D, res.texture);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, input);
    }
  }]);

  return VideoTextureLoader;
}(_webgltextureLoader.WebGLTextureLoaderAsyncHashCache);

_webgltextureLoader.globalRegistry.add(VideoTextureLoader);

var _default = VideoTextureLoader;
exports["default"] = _default;